<template>
  <div>
    <wizard
      :wizard-data="wizardData"
      :wizard-config="wizardConfig"
      :loading="isWizarLoading"
    />
  </div>
</template>
<script>

import { mapGetters, mapActions } from 'vuex';

import Wizard from '@/febos/chile/approvals/wizardFlow/Wizard';
import config from '@/febos/chile/approvals/wizardFlow/config/wizard';

export default {
  components: {
    Wizard
  },
  data() {
    return {
      isWizarLoading: true,
      wizardConfig: this.$route.params.wizard
    };
  },
  computed: {
    ...mapGetters('Personalizacion', [
      'colors'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ]),
    ...mapGetters('Approvals', [
      'wizardData'
    ]),
    isFirstStep() {
      return this.currentStep === 0;
    },
    isLastStep() {
      return this.currentStep >= this.wizard.steps.length - 1;
    },
    mockedSteps() {
      return new Array(this.wizard.steps.length)
        .fill('');
    },
    currentStepSetting() {
      return this.wizard.steps[this.currentStep];
    }
  },
  methods: {
    ...mapActions('Approvals', [
      'clearWizardData',
      'loadWizardFileRepo',
      'addWizardData'
    ]),
    ...mapActions('List', [
      'fetchUserGroups'
    ])
  },
  async created() {
    this.isWizarLoading = true;
    this.clearWizardData();

    const {
      id,
      fileName,
      tipo,
      files,
      repositoryId,
      folderId,
      ownerId
    } = this.$route.params;
    if (id === 'masivo') {
      if (tipo === 'files' && !files) {
        // eslint-disable-next-line no-restricted-globals
        history.back();
      }
      await this.addWizardData({
        fileName,
        tipo,
        files,
        repositoryId,
        folderId,
        ownerId
      });
    } else if (id) {
      const wizardFactory = config[this.wizardConfig];
      const wizard = typeof wizardFactory === 'function'
        ? wizardFactory()
        : null;
      await this.loadWizardFileRepo({
        id,
        mapper: wizard?.wizardMapper
      });
    }
    await this.fetchUserGroups();
    this.isWizarLoading = false;
  },
  destroyed() {
    this.clearWizardData();
  }
};
</script>

<style lang="scss">

@import "~vue-step-progress/dist/main.css";

</style>
